interface HelpProps {
    children: React.ReactNode;
}

const Help = ({ children }: HelpProps) => {
    return (
        <div className="w-full flex flex-row justify-between text-sm text-gray-500 font-sans font-normal leading-5 tracking-normal">
            {children}
        </div>
    );
};

export default Help;